export class CommentDTO{
  plateid: string ;
  status:string;
  beadchipstatus:string;
  labid: string ;
  comment: string ;
  beadchipid: string ;
  puid: string ;
  platecomment: boolean ;
}

export class MultiCommentDTO{
  plateids: Array<string> ;
  status:string;
  beadchipstatus:string;
  labid: string ;
  comment: string ;
  beadchipids: Array<string> ;
  puid: string ;
  platecomment: boolean ;
}

export class MultiCommentStatusDTO{
  plateids: Array<string> ;
  status:any;
  beadchipstatus:string;
  labid: string ;
  comment: string ;
  beadchipids: Array<string> ;
  puid: string ;
  platecomment: boolean ;
}

